import { WorkerRunStatus } from "@validereinc/domain";
import { z } from "zod";

export const WorkerRunsTableFilterSchema = z
  .object({
    workerId: z.string(),
    version: z.number(),
    status: z.array(z.union([z.literal(""), z.nativeEnum(WorkerRunStatus)])),
  })
  .partial();

export const WorkerRunTableFilterSchemaKeys =
  WorkerRunsTableFilterSchema.keyof().Enum;

export type WorkerRunTableFiltersType = z.infer<
  typeof WorkerRunsTableFilterSchema
>;
